import { render, staticRenderFns } from "./PerSubjectPieChart.vue?vue&type=template&id=17319e04&"
import script from "./PerSubjectPieChart.vue?vue&type=script&lang=ts&"
export * from "./PerSubjectPieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports